function safeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

function statusKey(v) {
  return safeString(v).trim().toUpperCase().replace(/[\s-]+/g, "_");
}

function firstNonBlank(...values) {
  for (const value of values) {
    const s = safeString(value).trim();
    if (s) return s;
  }
  return "";
}

export function isArchivedLikeRO(ro) {
  const status = statusKey(ro?.status);
  const lifecycle = statusKey(ro?.lifecycle || ro?.lifeCycle);

  return (
    status === "ARCHIVED" ||
    lifecycle === "ARCHIVED" ||
    !!ro?.archivedAt ||
    !!ro?.archivedAtISO ||
    !!ro?.timestamps?.archivedAt
  );
}

export function isVehicleGoneLikeRO(ro) {
  const status = statusKey(ro?.status);
  const lifecycle = statusKey(ro?.lifecycle || ro?.lifeCycle);
  const pickupStatus = statusKey(
    ro?.customerPickupStatus || ro?.customer_pickup_status
  );
  const advisorAction = statusKey(
    ro?.advisorActionStatus || ro?.advisor_action_status
  );

  return (
    status === "VEHICLE_GONE" ||
    status === "PICKED_UP" ||
    lifecycle === "VEHICLE_GONE" ||
    lifecycle === "PICKED_UP" ||
    pickupStatus === "VEHICLE_GONE" ||
    pickupStatus === "PICKED_UP" ||
    advisorAction === "VEHICLE_GONE" ||
    advisorAction === "PICKED_UP" ||
    !!ro?.vehicleGone ||
    !!ro?.vehicle_gone ||
    !!ro?.pickedUp ||
    !!ro?.picked_up ||
    !!ro?.pickedUpAt ||
    !!ro?.picked_up_at ||
    !!ro?.pickedUpAtISO ||
    !!ro?.picked_up_at_iso ||
    !!ro?.vehicleGoneAt ||
    !!ro?.vehicle_gone_at ||
    !!ro?.vehicleGoneAtISO ||
    !!ro?.vehicle_gone_at_iso ||
    !!ro?.timestamps?.vehicleGoneAt ||
    !!ro?.timestamps?.vehicle_gone_at ||
    !!ro?.timestamps?.pickedUpAt ||
    !!ro?.timestamps?.picked_up_at
  );
}

export function isCompletedLikeRO(ro) {
  const status = statusKey(ro?.status);
  const lifecycle = statusKey(ro?.lifecycle || ro?.lifeCycle);

  return (
    status === "COMPLETED" ||
    status === "REPAIRS_COMPLETE" ||
    status === "DONE" ||
    lifecycle === "COMPLETED" ||
    lifecycle === "COMPLETE" ||
    lifecycle === "DONE"
  );
}

export function getManagerDashboardOperationalStatus(ro) {
  const status = statusKey(ro?.status);
  const lifecycle = statusKey(ro?.lifecycle || ro?.lifeCycle);
  const displayStatus = statusKey(
    ro?.displayStatus ||
      ro?.display_status ||
      ro?.boardStatus ||
      ro?.board_status ||
      ro?.statusDisplay ||
      ro?.status_display
  );
  const partsStatus = statusKey(ro?.partsStatus || ro?.parts_status);
  const partsActionStatus = statusKey(
    ro?.partsActionStatus || ro?.parts_action_status
  );
  const partsRequestType = statusKey(
    ro?.partsRequestType || ro?.parts_request_type
  );
  const assigned = !!firstNonBlank(
    ro?.assignedTechId,
    ro?.assigned_tech_id,
    ro?.techId,
    ro?.assignedToId,
    ro?.assignedTechName,
    ro?.assigned_tech_name,
    ro?.techName,
    ro?.assignedTo
  );
  const activeWork = !!firstNonBlank(
    ro?.activeWorkStartedAtISO,
    ro?.active_work_started_at_iso,
    ro?.timestamps?.activeWorkStartedAtISO,
    ro?.timestamps?.activeWorkStartedAt,
    ro?.timestamps?.workStartAt
  ) && !firstNonBlank(
    ro?.workEndedAtISO,
    ro?.work_ended_at_iso,
    ro?.lastStoppedAtISO,
    ro?.last_stopped_at_iso,
    ro?.timestamps?.workEndAt,
    ro?.timestamps?.stoppedAt
  );

  if (isVehicleGoneLikeRO(ro)) {
    return { key: "VEHICLE_GONE", label: "Vehicle Gone" };
  }

  if (isArchivedLikeRO(ro)) {
    return { key: "ARCHIVED", label: "Archived" };
  }

  if (isCompletedLikeRO(ro)) {
    return { key: "COMPLETED", label: "Completed" };
  }

  const hasOpenPartsRequest =
    (partsRequestType === "NEED_PARTS" ||
      partsRequestType === "NEED_PRICE" ||
      partsRequestType === "PARTS_NEEDED" ||
      partsRequestType === "QUOTE_NEEDED") &&
    (!partsActionStatus ||
      partsActionStatus === "REVIEW" ||
      partsActionStatus === "OPEN" ||
      partsActionStatus === "REOPEN");

  const waitingParts =
    lifecycle === "WAITING_FOR_PARTS" ||
    lifecycle === "WAITING_ON_PARTS" ||
    status === "WAITING_FOR_PARTS" ||
    status === "WAITING_ON_PARTS" ||
    status === "WAITING_PARTS" ||
    displayStatus === "WAITING_FOR_PARTS" ||
    displayStatus === "WAITING_PARTS" ||
    partsStatus === "ORDERED" ||
    partsStatus === "WAITING" ||
    partsStatus === "WAITING_PARTS" ||
    partsStatus === "WAITING_FOR_PARTS" ||
    partsActionStatus === "ORDERED" ||
    partsActionStatus === "PARTS_ORDERED" ||
    partsActionStatus === "WAITING_PARTS" ||
    partsActionStatus === "WAITING_FOR_PARTS" ||
    hasOpenPartsRequest;

  if (waitingParts) {
    return { key: "WAITING_PARTS", label: "Waiting Parts" };
  }

  if (lifecycle === "IN_PROGRESS" || status === "IN_PROGRESS" || activeWork) {
    return { key: "IN_PROGRESS", label: "In Progress" };
  }

  if (status === "ON_HOLD" || status === "VEHICLE_HOLD") {
    return { key: "ON_HOLD", label: "On Hold" };
  }

  if (
    status === "ASSIGNED" ||
    displayStatus === "ASSIGNED" ||
    assigned
  ) {
    return { key: "ASSIGNED", label: "Assigned" };
  }

  return { key: "UNASSIGNED", label: "Unassigned" };
}

export function isAdvisorDashboardActiveRO(ro) {
  return !isArchivedLikeRO(ro) && !isVehicleGoneLikeRO(ro) && !isCompletedLikeRO(ro);
}

export function isAdvisorDashboardCompletedRO(ro) {
  return !isArchivedLikeRO(ro) && !isVehicleGoneLikeRO(ro) && isCompletedLikeRO(ro);
}
